import { fontFamily } from "src/global.style";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 16rem;
  min-height: 5vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  margin-left: auto;
  margin-right: auto;
`;
export const Image = styled.div`
  overflow: hidden;
  width: 60px;
  height: 60px;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }

  img {
    width: 100%;
    max-width: 16.125rem;
  }
`;
export const Title = styled.div`
  font-size: 1.375rem;
  line-height: 1.5rem;
  font-family: ${fontFamily.brand};
  font-size: ${(props) => (props.blog ? "20px" : "24px")};
  color: ${({ color }) => color};
`;
export const Description = styled.div`
  width: 90%;
  font-family: ${fontFamily.neutral};
  font-size: 1rem;
  letter-spacing: 0;
  line-height: 1.5rem;
  text-align: center;
  color: ${({ color }) => color};
`;
